import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EditableDate } from 'src/app/product-capture/model/interfaces/editable-date.interface';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dc-original-and-edited-date-input',
  templateUrl: './dc-original-and-edited-date-input.component.html',
})
export class DcOriginalAndEditedDateInputComponent
  implements AfterViewInit, OnDestroy
{
  @Input() id: string;
  @Input() originalAndEditedDate: EditableDate & { userEdited: NgbDateStruct };

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    editedDate: new UntypedFormControl(null),
  });

  private destroy$ = new Subject();

  constructor() {}

  ngAfterViewInit(): void {
    if (!this.originalAndEditedDate) {
      return;
    }

    const { edited, original } = this.originalAndEditedDate;

    // Need to set `editedDate` to `original` if `edited` is null
    // So that the date picker will show the original date in edit mode
    this.formGroup
      .get('editedDate')
      .setValue((edited as NgbDateStruct) ?? (original as NgbDateStruct));

    this.formGroup
      .get('editedDate')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.originalAndEditedDate.userEdited = value;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
